// import React, { useState, useEffect } from 'react';
// import {
//   Button,
//   Container,
//   FormControl,
//   InputLabel,
//   Box,
//   Modal,
//   Tooltip,
//   MenuItem,
//   Select,
//   Paper,
//   TextField,
//   Typography,
//   useTheme
// } from '@mui/material';
// import { InputAdornment } from '@mui/material';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import { useNavigate } from 'react-router-dom';

// // Wrap your app with <ThemeProvider theme={theme}>
// const AddIdCard = () => {
//   const theme=useTheme()
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
//   const [candidateId, setCandidateId] = useState('');
//   const [issueDate, setIssueDate] = useState('');
//   const [expiryDate, setExpiryDate] = useState('');
//   const navigate = useNavigate();

//   // Static data for candidates
//   const staticCandidateData = [
//     { candidateId: 1, candidateName: 'John Doe' },
//     { candidateId: 2, candidateName: 'Jane Smith' },
//     { candidateId: 3, candidateName: 'Alice Johnson' },
//     { candidateId: 4, candidateName: 'Bob Brown' },
//     { candidateId: 5, candidateName: 'Charlie Davis' },
//   ];

//   useEffect(() => {
//     // Set the issue date to today's date when the component mounts
//     const today = new Date();
//     const formattedDate = today.toISOString().split('T')[0];
//     setIssueDate(formattedDate);
//   }, []);

//   const handleSave = (e) => {
//     e.preventDefault();
//     if (candidateId && issueDate && expiryDate) {
//       setShowSuccessModal(true);
//     } else {
//       alert('Please fill all fields');
//     }
//   };

//   const handleCancel = () => {
//     setCandidateId('');
//     setIssueDate('');
//     setExpiryDate('');
//   };

//   return (
//     <Container>
//       <Box
//         sx={{
//           backgroundColor: 'rgba(2, 78, 101, 1)',
//           padding: '12px 16px',
//           boxShadow: 3,
//           borderRadius: '4px 4px 0 0',
//           margin: '0 auto',
//           width: "100%",
//         }}
//       >
//         <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
//           Add ID Card
//         </Typography>
//       </Box>
//       <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
//         <div>
//           <FormControl fullWidth sx={{ my: 2 }}>
//             <InputLabel htmlFor="candidate">Candidate Name:</InputLabel>
//             <Select
//               id="candidate"
//               value={candidateId}
//               label="Candidate Name"
//               onChange={(e) => setCandidateId(e.target.value)}
//             >
//               {staticCandidateData.map((candidate) => (
//                 <MenuItem key={candidate.candidateId} value={candidate.candidateId}>
//                   {candidate.candidateName}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//    <TextField
//   type="date"
//   value={issueDate}
//   onChange={(e) => setIssueDate(e.target.value)}
//   InputLabelProps={{ shrink: true }}
//   InputProps={{
//     endAdornment: (
//       <InputAdornment position="end">
//         <CalendarTodayIcon
//           sx={{
//             // FIX: Use the theme from the component context
//             color: theme.palette.mode === 'dark' ? '#fff' : 'inherit',
//           }}
//         />
//       </InputAdornment>
//     ),
//     sx: {
//       // Hide the default browser calendar icon
//       '& input::-webkit-calendar-picker-indicator': {
//         display: 'none',
//       },
//       // Ensure the custom icon is clickable
//       '& input': {
//         cursor: 'pointer',
//       },
//     },
//   }}
//   sx={{
//     mb: 3,
//     '& .MuiInputLabel-root': {
//       color: theme.palette.text.primary,
//     },
//     '& .MuiInputLabel-root.Mui-focused': {
//       color: theme.palette.primary.main,
//     },
//     '& .MuiOutlinedInput-notchedOutline': {
//       borderColor: theme.palette.text.primary,
//     },
//     '&:hover .MuiOutlinedInput-notchedOutline': {
//       borderColor: theme.palette.primary.main,
//     },
//   }}
// />
//           <TextField
//             label="Expiry Date"
//             type="date"
//             variant="outlined"
//             fullWidth
//             value={expiryDate}
//             onChange={(e) => setExpiryDate(e.target.value)}
//              sx={{
//                 mb: 3,
//                 '& .MuiInputLabel-root': {
//                   color: theme.palette.text.primary,
//                 },
//                 '& .MuiInputLabel-root.Mui-focused': {
//                   color: theme.palette.primary.main,
//                 },
//                 '& .MuiOutlinedInput-notchedOutline': {
//                   borderColor: theme.palette.text.primary,
//                 },
//                 '&:hover .MuiOutlinedInput-notchedOutline': {
//                   borderColor: theme.palette.primary.main,
//                 },
//                '& input[type="date"]::-webkit-calendar-picker-indicator': {
//   filter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
//   opacity: theme.palette.mode === 'dark' ? 1 : undefined,
//   WebkitFilter: theme.palette.mode === 'dark' ? 'invert(1)' : 'none',
// },



//               }}
//             InputLabelProps={{ shrink: true }}
//           />
//           <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
//             <Tooltip title={!candidateId ? "Select Candidate" : !issueDate ? "Select Issue Date" : !expiryDate ? "Select Expiry Date" : ""} arrow>
//               <span>
//                 <Button
//                   variant="contained"
//                   onClick={handleSave}
//                   sx={{
//                     mr: 2,
//                     backgroundColor: '#127498ff',
//                     '&:hover': { backgroundColor: '#116280ff' }
//                   }}
//                   disabled={!candidateId || !issueDate || !expiryDate}
//                 >
//                   SAVE
//                 </Button>
//               </span>
//             </Tooltip>
//             <Button
//               variant="contained"
//               color="error"
//               onClick={handleCancel}
//             >
//               RESET
//             </Button>
//           </Box>
//         </div>
//       </Paper>
//       <Modal
//         open={showSuccessModal}
//         onClose={() => setShowSuccessModal(false)}
//         aria-labelledby="success-modal-title"
//         aria-describedby="success-modal-description"
//       >
//         <Box
//           sx={{
//             position: 'absolute',
//             top: '50%',
//             left: '50%',
//             transform: 'translate(-50%, -50%)',
//             width: 400,
//             bgcolor: 'background.paper',
//             borderRadius: 2,
//             boxShadow: 24,
//             overflow: 'hidden',
//           }}
//         >
//           <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
//             <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
//               ID Card Added ✅
//             </Typography>
//           </Box>
//           <Box sx={{ padding: '20px' }}>
//             <Typography id="success-modal-description" sx={{ mb: 2 }}>
//               ID Card Added Successfully
//             </Typography>
//             <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
//               <Button
//                 onClick={() => {
//                   setShowSuccessModal(false);
//                   navigate(-1);
//                 }}
//                 variant="contained"
//                 color="primary"
//               >
//                 OK
//               </Button>
//             </Box>
//           </Box>
//         </Box>
//       </Modal>
//     </Container>
//   );
// };

// export default AddIdCard;
import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  FormControl,
  InputLabel,
  Box,
  Modal,
  Tooltip,
  MenuItem,
  Select,
  Paper,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AddIdCard = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [candidateId, setCandidateId] = useState('');
  const [issueDate, setIssueDate] = useState('');
  const [expiryDate, setExpiryDate] = useState('');

  // Static data for candidates
  const staticCandidateData = [
    { candidateId: 1, candidateName: 'John Doe' },
    { candidateId: 2, candidateName: 'Jane Smith' },
    { candidateId: 3, candidateName: 'Alice Johnson' },
    { candidateId: 4, candidateName: 'Bob Brown' },
    { candidateId: 5, candidateName: 'Charlie Davis' },
  ];

  useEffect(() => {
    // Set the issue date to today's date when the component mounts
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    setIssueDate(formattedDate);
  }, []);

  const handleSave = (e) => {
    e.preventDefault();
    if (candidateId && issueDate && expiryDate) {
      setShowSuccessModal(true);
    } else {
      alert('Please fill all fields');
    }
  };

  const handleCancel = () => {
    setCandidateId('');
    setIssueDate('');
    setExpiryDate('');
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
        }}
      >
        <Typography variant="h5" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Add ID Card
        </Typography>
      </Box>

      <Paper
        elevation={3}
        sx={{
          padding: 3,
          marginTop: 0,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel
            id="candidate-label"
            sx={{
              color: theme.palette.text.primary,
              '&.Mui-focused': {
                color: theme.palette.primary.main,
              },
            }}
          >
            Candidate Name
          </InputLabel>
          <Select
            labelId="candidate-label"
            id="candidate"
            value={candidateId}
            label="Candidate Name"
            onChange={(e) => setCandidateId(e.target.value)}
            sx={{
              color: theme.palette.text.primary,
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.text.primary,
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.main,
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.primary.main,
              },
            }}
          >
            {staticCandidateData.map((candidate) => (
              <MenuItem key={candidate.candidateId} value={candidate.candidateId}>
                {candidate.candidateName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Fixed Date Field */}
        <TextField
  label="Issue Date"
  type="date"
  fullWidth
  value={issueDate}
  onChange={(e) => setIssueDate(e.target.value)}
  InputLabelProps={{
    shrink: true,
    sx: {
      color: theme.palette.text.primary,
      '&.Mui-focused': {
        color: theme.palette.primary.main,
      },
    },
  }}
  InputProps={{
    sx: {
      '& input[type="date"]::-webkit-calendar-picker-indicator': {
        filter: theme.palette.mode === 'dark' ? 'invert(1) !important' : 'none',
      },
      '& input': {
        color: theme.palette.text.primary,
      },
    },
  }}
  sx={{
    mb: 3,
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: theme.palette.primary.main,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.primary,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
  }}
  required
/>

<TextField
  label="Expiry Date"
  type="date"
  fullWidth
  value={expiryDate}
  onChange={(e) => setExpiryDate(e.target.value)}
  InputLabelProps={{
    shrink: true,
    sx: {
      color: theme.palette.text.primary,
      '&.Mui-focused': {
        color: theme.palette.primary.main,
      },
    },
  }}
  InputProps={{
    sx: {
      '& input[type="date"]::-webkit-calendar-picker-indicator': {
        filter: theme.palette.mode === 'dark' ? 'invert(1) !important' : 'none',
      },
      '& input': {
        color: theme.palette.text.primary,
      },
    },
  }}
  sx={{
    mb: 3,
    '& .MuiInputLabel-root': {
      color: theme.palette.text.primary,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: theme.palette.primary.main,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.primary,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
  }}
  required
/>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 2 }}>
          <Tooltip
            title={
              !candidateId
                ? 'Select Candidate'
                : !issueDate
                ? 'Select Issue Date'
                : !expiryDate
                ? 'Select Expiry Date'
                : ''
            }
            arrow
          >
            <span>
              <Button
                variant="contained"
                onClick={handleSave}
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.dark },
                  '&:disabled': { backgroundColor: theme.palette.action.disabled },
                }}
                disabled={!candidateId || !issueDate || !expiryDate}
              >
                SAVE
              </Button>
            </span>
          </Tooltip>
          <Button variant="contained" color="error" onClick={handleCancel}>
            RESET
          </Button>
          <Button variant="outlined" color="secondary" onClick={() => navigate(-1)}>
            BACK
          </Button>
        </Box>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              ID Card Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              ID Card Added Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default AddIdCard;